import { render, staticRenderFns } from "./BusinessInformationUploadDocsPage.vue?vue&type=template&id=3f36601b"
import script from "./BusinessInformationUploadDocsPage.vue?vue&type=script&lang=js"
export * from "./BusinessInformationUploadDocsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports